import React, { useEffect, useState } from 'react';
import AuthLayout from '../layout/AuthLayout';
import RightPanelTopMenu from '../component/molecule/common/RightPanelTopMenu';
import Category from '../component/molecule/specific/MastersManagementScreens/Category';
import Identifier from '../component/molecule/specific/MastersManagementScreens/Identifier';
import LodComponent from '../component/molecule/specific/MastersManagementScreens/LOD';
import QuestionBank from '../component/molecule/specific/MastersManagementScreens/QuestionBank';
import SubjectPipeline from '../component/molecule/specific/MastersManagementScreens/SubjectPipeline';
import style from '../assets/styles/masterTemplate.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { Get_All_Category } from '../redux/action';
import { useNavigate } from 'react-router-dom';
import { Pagination } from '../component/molecule/common/Pagination';
const Masters = () => {
  // _________question bank id which is top dropdown _________
  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(15);
  const [offset, setOffset] = useState(0);
  const { masterScreen } = useSelector((state) => state.GetAllData);
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const userInfo = JSON.parse(localStorage.getItem('userInfo') ?? '{}');
  const Roles = userInfo.roles || [];
  const isOrganizationUser = Roles.some((role) => role.id === 10);
  // Get orgId from localStorage and set up state to manage it
  const [organizationId, setOrganizationId] = useState(() => {
    const storedId = localStorage.getItem('selectedOrgId');
    return storedId ? Number(storedId) : null;
  });

  useEffect(() => {
    setCurrentPage(1);
    setLimit(15);
    setOffset(0);
  }, [masterScreen, organizationId]);
  const navigate = useNavigate();
  useEffect(() => {
    if (isOrganizationUser) {
      alert('Access denied, only super admin or organization admin can access');
      navigate('/question-bank');
    }
  }, [isOrganizationUser]);

  return (
    <AuthLayout>
      {/* rightpannel top left menu according to different screen  */}
      <RightPanelTopMenu title={'Masters'} setOrganisationId={(id) => setOrganizationId(id)} showOrgDropdown={true} />

      {/* different screens according to the selection of masters  */}
      <div className={style.Master_div}>
        {masterScreen === 1 ? (
          <Category
            offset={offset}
            setOffset={setOffset}
            setCurrentPage={setCurrentPage}
            setTotalCount={setTotalCount}
            currentPage={currentPage}
          />
        ) : (
          ''
        )}
        {masterScreen === 2 ? (
          <Identifier
            offset={offset}
            setOffset={setOffset}
            setCurrentPage={setCurrentPage}
            setTotalCount={setTotalCount}
            currentPage={currentPage}
          />
        ) : (
          ''
        )}
        {masterScreen === 3 ? (
          <LodComponent
            offset={offset}
            setOffset={setOffset}
            setCurrentPage={setCurrentPage}
            setTotalCount={setTotalCount}
            currentPage={currentPage}
          />
        ) : (
          ''
        )}
        {masterScreen === 4 ? (
          <QuestionBank
            offset={offset}
            setOffset={setOffset}
            setCurrentPage={setCurrentPage}
            setTotalCount={setTotalCount}
            currentPage={currentPage}
          />
        ) : (
          ''
        )}
        {masterScreen === 5 ? (
          <SubjectPipeline
            offset={offset}
            setOffset={setOffset}
            setCurrentPage={setCurrentPage}
            setTotalCount={setTotalCount}
            currentPage={currentPage}
          />
        ) : (
          ''
        )}
      </div>
      {/*______________________________ PAGINATION ______________________________  */}
      <div className={style.MasterpaginationWrap}>
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          limit={limit}
          totalCount={totalCount}
          offset={offset}
          setOffset={setOffset}
        />
      </div>
    </AuthLayout>
  );
};

export default Masters;
